enum AudioEvent {
  END = 'end',
  PAUSE = 'pause',
  PLAY = 'play',
  SEEK = 'seek',
  TIMEUPDATE = 'timeupdate',
}

export default AudioEvent;
